import { Shield, Lock, GraduationCap, ClipboardCheck } from "lucide-react";

const TrustSection = () => {
  const trustItems = [
    {
      icon: Shield,
      title: "HIPAA-Compliant Workflows",
      description: "Every process designed and audited for full HIPAA compliance",
    },
    {
      icon: Lock,
      title: "Secure Patient Data Handling",
      description: "Enterprise-grade encryption and access controls protect all data",
    },
    {
      icon: GraduationCap,
      title: "Trained Medical Scribes",
      description: "Professional scribes with healthcare documentation expertise",
    },
    {
      icon: ClipboardCheck,
      title: "Quality Control & Review",
      description: "Multi-layer review process ensures accuracy and consistency",
    },
  ];

  return (
    <section 
      data-testid="trust-section"
      className="py-16 sm:py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="text-xs sm:text-sm font-medium uppercase tracking-widest text-cyan-500 mb-3 sm:mb-4 block">
            Why Trust Us
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-3 sm:mb-4">
            Built for Healthcare Trust
          </h2>
          <p className="text-base sm:text-lg text-slate-400 max-w-2xl mx-auto px-4">
            Security and compliance are at the core of everything we do
          </p>
        </div>

        {/* Trust Grid */}
        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6">
          {trustItems.map((item, index) => (
            <div 
              key={index}
              className="glass-card p-5 sm:p-8 flex items-start gap-4 sm:gap-6 group hover:border-cyan-500/30 transition-all"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center flex-shrink-0 group-hover:bg-cyan-500/20 transition-colors">
                <item.icon className="w-6 h-6 sm:w-7 sm:h-7 text-cyan-400" />
              </div>
              <div className="min-w-0">
                <h3 className="text-base sm:text-xl font-semibold text-white mb-1 sm:mb-2">{item.title}</h3>
                <p className="text-sm sm:text-base text-slate-400 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Compliance Badges */}
        <div className="mt-8 sm:mt-12 flex flex-wrap justify-center gap-2 sm:gap-4">
          <div className="px-4 sm:px-6 py-2 sm:py-3 rounded-full bg-[#111] border border-white/10 flex items-center gap-2 sm:gap-3">
            <Shield className="w-4 h-4 sm:w-5 sm:h-5 text-green-500" />
            <span className="text-xs sm:text-sm text-slate-300">HIPAA Certified</span>
          </div>
          <div className="px-4 sm:px-6 py-2 sm:py-3 rounded-full bg-[#111] border border-white/10 flex items-center gap-2 sm:gap-3">
            <Lock className="w-4 h-4 sm:w-5 sm:h-5 text-cyan-500" />
            <span className="text-xs sm:text-sm text-slate-300">SOC 2 Type II</span>
          </div>
          <div className="px-4 sm:px-6 py-2 sm:py-3 rounded-full bg-[#111] border border-white/10 flex items-center gap-2 sm:gap-3">
            <ClipboardCheck className="w-4 h-4 sm:w-5 sm:h-5 text-cyan-500" />
            <span className="text-xs sm:text-sm text-slate-300">256-bit Encryption</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
